import { render, staticRenderFns } from "./pregnancy.vue?vue&type=template&id=32cbf0c7&scoped=true&"
import script from "./pregnancy.vue?vue&type=script&lang=js&"
export * from "./pregnancy.vue?vue&type=script&lang=js&"
import style0 from "./pregnancy.vue?vue&type=style&index=0&id=32cbf0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbf0c7",
  null
  
)

export default component.exports